module.exports = __webpack_public_path__ + "img/573d466.png";